import React from 'react';
import PropTypes from 'prop-types';
import Info from 'Components/Info';

export const selectType = {
  primary: 'primary',
  primarySmall: 'primary_small',
  secondary: 'secondary',
  listFilter: 'filters',
  listActions: 'actions',
};

class Select extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      filterValue: null,
      selectedItem: '',
      keySelectedIndex: -1,
      textWrappersRefs: [],
    };

    this.inputRef = React.createRef();
    this.keySelectedIndex = -1;
    this.uniqueIdNumber = Math.floor(Math.random()*9000);
  }

  shouldComponentUpdate(nextProps) {
    if (this.getValue(nextProps.defaultItem) !== this.getValue(this.props.defaultItem)) {
      this.setState({selectedItem: nextProps.defaultItem});
    }

    return true;
  }

  componentDidUpdate() {
    if (this.props.isSlave && this.props.defaultItem === '' && this.state.selectedItem !== '') {
      this.setState({selectedItem: ''});
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeDropDown);
    document.removeEventListener('keydown', this._keyboardActions);
  }

  _keyboardActions = event => {
    const {isOpen} = this.state;

    if (isOpen) {
      event.stopPropagation();
      if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();

      this.keySelectedIndex = this.state.keySelectedIndex;
      switch (event.key) {
        case 'ArrowDown':
        case 'Down':
          return this.setState(prevState => {
            let keySelectedIndex = this.props.selectionList.length - 1;

            if (prevState.keySelectedIndex !== keySelectedIndex) {
              keySelectedIndex = ++prevState.keySelectedIndex;
            }

            return {keySelectedIndex};
          });
        case 'ArrowUp':
        case 'Up':
          return this.setState(prevState => {
            let keySelectedIndex = -1;

            if (prevState.keySelectedIndex !== keySelectedIndex) {
              keySelectedIndex = --prevState.keySelectedIndex;
            }

            return {keySelectedIndex};
          });
        case 'Enter':
          if (this.state.keySelectedIndex !== -1) {
            this.handleSelect(this.props.selectionList[this.state.keySelectedIndex], this.state.keySelectedIndex)(event);
          }
      }
    }
  };

  getValue = selectedItem => {
    const {itemNameIndicator} = this.props;

    if (itemNameIndicator === '') {
      return selectedItem.toString();
    } else if (typeof itemNameIndicator === 'string') {
      return selectedItem[itemNameIndicator] || '';
    } else if (itemNameIndicator.length !== undefined) {
      return itemNameIndicator
        .reduce((string, indicator) => {
          if (selectedItem[indicator] === undefined) return string;
          return string + selectedItem[indicator] + ' - ';
        }, '')
        .slice(0, -3);
    }
  };

  getSelectedValue = () => {
    const {isSlave} = this.props;
    const {selectedItem, filterValue} = this.state;

    if (filterValue === null) {
      if (selectedItem === '' || isSlave) return this.getValue(this.props.defaultItem);
      else return this.getValue(selectedItem);
    }
    return filterValue;
  };

  getDropDownList = () => {
    const {filterValue, textWrappersRefs} = this.state;
    const {selectionList, itemClassName, type, withCheckBoxes, defaultItem, isSlave, checkBoxClassName, disabledInfoText} = this.props;

    return selectionList
      .filter(element => {
        if (filterValue === null) return true;

        const el = this.getValue(element).toLowerCase();
        return el.indexOf(filterValue.toLowerCase()) !== -1;
      })
      .map((element, index) => {
        const selectedByKeyboard = this.state.keySelectedIndex !== -1 && index === this.state.keySelectedIndex;
        const isSelectedItem = isSlave ? element === defaultItem : element === this.state.selectedItem;
        const selectedClass =  selectedByKeyboard || (this.state.keySelectedIndex === -1 && isSelectedItem) ? 'select__drop-down-item_selected' : '';

        if (withCheckBoxes && element.disabled && disabledInfoText) return(
          <Info triggerElement={
            <div
              key={index}
              className={`select__drop-down-item select__drop-down-item_${type} ${itemClassName} ${selectedClass} select__drop-down-item_${type}_with-checkbox ${element.disabled ? 'select__drop-down-item_disabled' : ''}`}
              onClick={this.handleSelect(element, index)}
            >
              <div className='select__drop-down-item-tex-wrapper'
                style={{right: this.getTextWrapperRightShift(textWrappersRefs[index])}}
                ref={this.saveTextWrapperRef}>
                {this.getValue(element)}
              </div>
              <div className={`select__checkBoxIcon
              ${element.checked ? '__checkbox_checked' : '__checkbox_empty'}
              ${checkBoxClassName || '_top_0 _left_0'} _position_absolute `} />
            </div>
          }
          popperElement={
            <div className='info__tooltip-body'>
              {disabledInfoText}
            </div>
          } />
        );

        return (
          <div
            key={index}
            className={`select__drop-down-item select__drop-down-item_${type} ${itemClassName} ${selectedClass}
               ${withCheckBoxes ? `select__drop-down-item_${type}_with-checkbox` : ''}
               ${withCheckBoxes && element.disabled ? 'select__drop-down-item_disabled' : ''}`}
            onClick={this.handleSelect(element, index)}
          >
            <div
              className='select__drop-down-item-tex-wrapper'
              style={{ right: this.getTextWrapperRightShift(textWrappersRefs[index]) }}
              ref={this.saveTextWrapperRef}
            >
              {this.getValue(element)}
            </div>
            {withCheckBoxes && (
              <div
                className={`select__checkBoxIcon
              ${element.checked ? '__checkbox_checked' : '__checkbox_empty'}
              ${checkBoxClassName || '_top_0 _left_0'} _position_absolute `}
              />
            )}
          </div>
        );
      });
  };

  saveTextWrapperRef = ref => {
    let {textWrappersRefs} = this.state;
    textWrappersRefs.push(ref);
    this.setState({textWrappersRefs})
  };

  getTextWrapperRightShift = DOMObj => {
    if (DOMObj) {
      return  DOMObj.scrollWidth - DOMObj.offsetWidth;
    }

    return 0;
  };

  openDropDown = event => {
    event.stopPropagation();
    if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();

    if (!this.state.isOpen) {
      if (this.props.withoutSearch) {
        this.inputRef.current.blur();
      }

      let event = {};
      if(typeof(Event) === 'function') {
        event = new Event('click');
      }else{
        event = document.createEvent('Event');
        event.initEvent('click', true, true);
      }
      document.dispatchEvent(event);

      this.setState({
        isOpen: true,
        filterValue: this.props.withoutSearch ? null : ''
      }, () => {
        this.inputRef.current.focus();
        document.addEventListener('click', this.closeDropDown);
        document.addEventListener('keydown', this._keyboardActions, true);
        this.forceUpdate();
      });
    }
  };

  closeDropDown = event => {
    if (this.state.isOpen) {
      document.removeEventListener('click', this.closeDropDown);
      document.removeEventListener('keydown', this._keyboardActions);

      this.setState({isOpen: false, filterValue: null, keySelectedIndex: -1});
    }
  };

  handleInputChange = ({target}) => {
    this.setState({filterValue: target.value});
  };

  handleSelect = (selectedItem, keySelectedIndex) => event => {
    event.stopPropagation();
    if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();

    if (!this.props.multiSelect) {
      this.setState({selectedItem, keySelectedIndex, filterValue:null}, () => {
        this.props.handleSelect(selectedItem);
        if (!(document.documentMode || /Edge/.test(navigator.userAgent))) this.inputRef.current.focus();
        this.closeDropDown();
      });
    } else {
      this.props.handleSelect(selectedItem, event);
    }
  };

  handleClearInputClick = event => {
    const {selectedItem, filterValue} = this.state;
    const {defaultItem, handleSelect, unclearable} = this.props;

    if ((selectedItem || filterValue || defaultItem) && !unclearable) {
      event.stopPropagation();
      if (event.nativeEvent) event.nativeEvent.stopImmediatePropagation();

      this.setState({selectedItem: '', filterValue: null, keySelectedIndex: -1}, () => {
        if (defaultItem) handleSelect('', event);
      });
    }
  };

  render() {
    const {isOpen} = this.state;
    const {
      type,
      label,
      placeholder,
      error,
      capitalizeLabel,
      disabled,
      inputClassName,
      dropDownClassName,
      mainWrapperClassName,
      inputFieldWrapperClassName,
      labelClassName,
      iconClassName,
      isLoading,
      tabIndex,
      withoutSearch,
      unclearable,
      selectAll,
      unselectAll,
    } = this.props;

    const updatedLabel = label && capitalizeLabel ? label[0].toUpperCase() + label.slice(1).toLowerCase() : label;
    const errorTextElement = error ? <div className='select__error'>{error}</div> : null;
    const inputValue = this.getSelectedValue();

    const isOpenClass = isOpen ? 'open' : '';
    const errorClass = `${error ? 'error' : ''}`;
    const mainWrapperOldOrNewClass = (type === selectType.listFilter ||
      type === selectType.listActions ||
      type === selectType.primary ||
      type === selectType.primarySmall)
      ?
      `select__main-wrapper select__main-wrapper_${type}`
      :
      'ect-select';

    const leaveSpaceForLabelButtons = (!updatedLabel && (selectAll || unselectAll));

    const mainWrapperClasses = `${mainWrapperOldOrNewClass} ${errorClass} ${type} ${mainWrapperClassName} ${leaveSpaceForLabelButtons ? '_padding_top_20' : ''}`;
    const labelClasses = `select__label select__label_${type} ${labelClassName}`;
    const inputFieldWrapperClasses = `select__input-field-wrapper
    select__input-field-wrapper_${type} ${inputFieldWrapperClassName}`;
    const loadPlaceholderClasses = `select__loading-placeholder select__loading-placeholder_${type} ${inputClassName}`;
    const inputFieldClasses = `select__input select__input_${type}
                   ${withoutSearch ? `select__input_${type}_not-searchable` : ''}
                   ${inputClassName} ${disabled ? `select__input_${type}_disabled` : ''} ${isOpenClass} ${errorClass}`;
    const inputFieldIconClasses = `select__input-icon select__input-icon_${type}
              ${(inputValue && !unclearable) && `select__input-icon_${type}_clear-mode`}
              ${iconClassName} ${leaveSpaceForLabelButtons ? '_top_25' : ''}`;
    const dropDownListClasses = `select__drop-down-list select__drop-down-list_${type}
    ${isOpenClass} ${dropDownClassName}`;

    return (
      <div className={mainWrapperClasses}>
        {isOpen && (selectAll || unselectAll) && (
          <div className='select__label-buttons-placeholder'>
            {selectAll && (
              <div className='select__sub-label _cursor_pointer' onClick={selectAll}>
                Select All
              </div>
            )}
            <div className='select__sub-label _cursor_pointer' onClick={unselectAll}>
              Unselect All
            </div>
          </div>
        )}

        {updatedLabel && (
          <label htmlFor={'ect-select-field_' + this.uniqueIdNumber} className={labelClasses}>
            {updatedLabel}
          </label>
        )}

        <div className={inputFieldWrapperClasses}>
          {!disabled && isLoading ? (
            <div className={loadPlaceholderClasses}>
              <div className='jumping-dot' />
              <div className='jumping-dot' />
              <div className='jumping-dot' />
            </div>
          ) : (
            <React.Fragment>
              <input
                id={'ect-select-field_' + this.uniqueIdNumber}
                value={inputValue}
                className={inputFieldClasses}
                placeholder={placeholder}
                disabled={disabled}
                onChange={this.handleInputChange}
                tabIndex={tabIndex}
                ref={this.inputRef}
                autoComplete='off'
                onFocus={this.openDropDown}
                onClick={this.openDropDown}
              />
              {!withoutSearch && !disabled && (
                <div className={inputFieldIconClasses} onClick={this.handleClearInputClick} />
              )}
            </React.Fragment>
          )}
          {errorTextElement}
        </div>

        <div className={dropDownListClasses}>{this.getDropDownList()}</div>
      </div>
    );
  }
}

Select.propTypes = {
  defaultItem: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.object
  ]),
  handleSelect: PropTypes.func.isRequired,
  selectionList: PropTypes.array,
  type: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  placeholder: PropTypes.string,
  itemNameIndicator: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool
  ]),
  capitalizeLabel: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  multiSelect: PropTypes.bool,
  isSlave: PropTypes.bool,
  inputClassName: PropTypes.string,
  dropDownClassName: PropTypes.string,
  mainWrapperClassName: PropTypes.string,
  inputFieldWrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  itemClassName: PropTypes.string,
  tabIndex: PropTypes.number,
  withoutSearch: PropTypes.bool,
  unclearable: PropTypes.bool,
  withCheckBoxes: PropTypes.bool,
  checkBoxClassName: PropTypes.string,
  selectAll: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
  unselectAll: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func
  ]),
};

Select.defaultProps = {
  defaultItem: '',
  handleSelect: () => {},
  selectionList: [],
  type: 'primary',
  label: '',
  placeholder: '',
  itemNameIndicator: '',
  error: '',
  capitalizeLabel: false,
  disabled: false,
  isLoading: false,
  multiSelect: false,
  isSlave: false,
  inputClassName: '',
  dropDownClassName: '',
  mainWrapperClassName: '',
  inputFieldWrapperClassName: '',
  labelClassName: '',
  iconClassName: '',
  itemClassName: '',
  tabIndex: 0,
  withoutSearch: false,
  unclearable: false,
  withCheckBoxes: false,
  checkBoxClassName: '',
  selectAll: false,
  unselectAll: false,
};

export default Select;



// WEBPACK FOOTER //
// ./src/app/Components/Select.jsx